import TableList from "@components/templates/tablelist";
import {
    HttpCreditList,
    HttpDelCredit
} from "@/service/credit";
import { mapGetters } from "vuex";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpCreditList,
        handleOperates(params = "", type, batch) {
            switch (type) {
                case "query":
                    var url = this.$router.resolve({
                        name: "creditUpdate",
                        params: { type: "query" },
                        query: { id: params},
                    });
                    window.open(url.href, '_blank');
                    break;
                case "edit":
                    this.operate = {
                        show: true,
                        params: {id: params, type: "edit" },
                        title: "编辑",
                        component: "compUpdate",
                        width: "middle",
                        showFooter: false
                    };
                    break;
                case "add":
                    this.operate = {
                        show: true,
                        params: { type: "add" },
                        title: "添加",
                        component: "compUpdate",
                        width: "middle",
                        showFooter: false
                    };
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: "删除",
                        desc: " 删除后不可恢复，是否确认删除？",
                        ajaxRequest: HttpDelCredit
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: "查看详情",
                    params: id,
                    show: true,
                    operate: "query"
                },
                {
                    label: "编辑",
                    params: id,
                    show: true,
                    operate: "edit"
                },
                {
                    label: "删除",
                    params: id,
                    show: true,
                    operate: "del"
                }
            ];
        }
    },
    computed: {
        ...mapGetters("dictionary", ["getNextOrgList"]),
        ToolsData() {
            return [
                {
                    label: "添加",
                    operate: "add",
                    theme: "primary"
                }
            ];
        },
        SearchsData() {
            return [
                {
                    label: "客户",
                    tag: "vSelect",
                    key: "EQ_organizationId",
                    options: this.getNextOrgList,
                    show: true,
                    props: {
                        filterable: true
                    }
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    show: true,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                    style: "width:250px",
                },
                {
                    label: "更新日期",
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    show: true,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                    style: "width:250px",
                }
            ];
        },
        columns() {
            return [
                {
                    title: "操作",
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: "客户",
                    key: "organizationId",
                    render: (h, { row }) => this.findRenderLabel(this.getNextOrgList, row.organizationId)
                },
                {
                    title: "信用额度(USD)",
                    key: "quota"
                },
                {
                    title: "创建人",
                    key: "createdName"
                },
                {
                    title: "创建日期",
                    key: "createdAt",
                    sortable: true
                },
                {
                    title: "更新日期",
                    key: "updatedAt",
                    sortable: true
                }
            ];
        }
    }
};
